export default "__VITE_ASSET__93d898c0__"